module.exports = __webpack_public_path__ + "img/manual.c89fb6f6.png";